import React, { useState } from 'react';
import { Link, Popover, Typography } from '@one-thd/sui-atomic-components';
import { Delivery, Subscription, Savings } from '@one-thd/sui-icons';
import { SUBSCRIBE_PARAGRAPH, SUBSCRIBE_POPOVER_TEXT_1, SUBSCRIBE_POPOVER_TEXT_2, SUBSCRIBE_POPOVER_TEXT_3, SUBSCRIPTION_TEXT_1, SUBSCRIPTION_TEXT_2, SUBSCRIBE_BULLET_TEXT_2, SUBSCRIBE_BULLET_TEXT_3, } from '../../../constants/order-details';
export var SubscriptionPopOverMessage = function () {
    var _a = useState(null), subscriptionAnchorEl = _a[0], setsubscriptionAnchorEl = _a[1];
    var handlePopOverClick = function (event) {
        setsubscriptionAnchorEl(event.target);
    };
    var handlePopOverClose = function () {
        setsubscriptionAnchorEl(null);
    };
    var open = Boolean(subscriptionAnchorEl);
    var id = open ? 'subscription-popover' : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { weight: "base", variant: "body-base" }, SUBSCRIPTION_TEXT_1),
        React.createElement(Typography, { weight: "base", variant: "body-base" }, SUBSCRIPTION_TEXT_2),
        React.createElement(Link, { "aria-describedby": id, onClick: handlePopOverClick }, "Learn more"),
        React.createElement(Popover, { id: id, open: open, anchorEl: subscriptionAnchorEl, onClose: handlePopOverClose, placement: "bottom-start", title: "Subscribe", className: "sui-z-max" },
            React.createElement("div", { className: "sui-flex sui-flex-col sui-items-start", "data-test-id": "subscription-popover" },
                React.createElement("div", { className: "sui-flex sui-gap-2" },
                    React.createElement(Delivery, null),
                    React.createElement(Typography, { weight: "base", variant: "body-base" }, SUBSCRIBE_POPOVER_TEXT_1)),
                React.createElement("div", { className: "sui-flex sui-gap-2 sui-mt-2" },
                    React.createElement(Subscription, null),
                    React.createElement(Typography, { weight: "base", variant: "body-base" }, SUBSCRIBE_POPOVER_TEXT_2)),
                React.createElement("div", { className: "sui-flex sui-gap-2 sui-mt-2" },
                    React.createElement(Savings, null),
                    React.createElement(Typography, { weight: "base", variant: "body-base" }, SUBSCRIBE_POPOVER_TEXT_3)),
                React.createElement("div", { className: "sui-flex sui-mt-4" },
                    React.createElement(Typography, { weight: "base", variant: "body-base" }, SUBSCRIBE_PARAGRAPH)),
                React.createElement("div", { className: "sui-bg-subtle sui-mt-4 sui-p-2 sui-rounded-xs" },
                    React.createElement("ul", { className: "sui-list-disc sui-ml-6" },
                        React.createElement("li", null,
                            React.createElement(Typography, null,
                                "You\u2019ll be charged the cost of the item at a",
                                ' ',
                                React.createElement("span", { className: "sui-font-bold" }, "5% discount"),
                                " (plus applicable taxes) on the day of each shipment.")),
                        React.createElement("li", null,
                            React.createElement(Typography, null, SUBSCRIBE_BULLET_TEXT_2)),
                        React.createElement("li", null,
                            React.createElement(Typography, null, SUBSCRIBE_BULLET_TEXT_3))))))));
};
export default SubscriptionPopOverMessage;
